export default {
  production: false,
  legalQuestionnaireReadOnly: false,
  Okta: {
    issuer: 'https://preview.wcgclinical.com/oauth2/default', // Set from Jenkins credentials: okta_issuer
    baseUrl: 'https://preview.wcgclinical.com', // Set from Jenkins credentials: okta_baseurl
    clientId: '0oaep2y5vlWth1uEF1d7', // Set from Jenkins credentials: okta_clientid
    redirectUri:
      'https://sbx-ermclinsphere.wcgclinical.com/auth/login/callback', // Set from Jenkins credentials: okta_redirecturi
    disableHttpsCheck: true,
    useClassicEngine: false,
    postLogoutRedirectUri: 'https://sbx-clinsphere.wcgclinical.com',
  },
  clinsphereUrl: 'https://sbx-clinsphere.wcgclinical.com',
  irisApi: 'https://sbx-ermclinsphere.wcgclinical.com/api',
  jemmaApi: 'https://sbx-clinsphere.wcgclinical.com/jemma/',
  jemmaEventSource: '7f90a79ddce16dd9350fabd4b2370744',
  workspaceNewVersion: true,
  enabledTask: false,
  irisWS: 'wss://sbx-ermclinsphere.wcgclinical.com/api/ws',
  appBaseHref: 'https://sbx-ermclinsphere.wcgclinical.com',
  oneTrustDomainScript: '0195ce24-ce88-71bd-a171-db22f030f613',
  insightInstrumentationKey: '', // Set from Jenkins credentials
  maxSessionLength: 24 * 60 * 60 * 1000,
  sessionTimeout: 58 * 60 * 1000,
  sessionGracePeriod: 2 * 60 * 1000,
  checkForOneTrustConsent: true,
  walkMeUrl:
    'https://cdn.walkme.com/users/ee75fa9a9e0e4c46bfdcf49e30de33b9/sandbox/walkme_ee75fa9a9e0e4c46bfdcf49e30de33b9_https.js',
  talkdesk: {
    accountId: '',
    region: 'td-us-1',
    touchpointId: '13f70f489bd84f97a04800afe9c94552',
    scriptUrl: 'https://talkdeskchatsdk.talkdeskapp.com/v2/talkdeskchatsdk.js',
    config: {
      enableValidation: true,
      enableEmoji: true,
      enableUserInput: true,
      enableAttachments: true,
      showInitialScreen: true,
      chatTitle: 'Live chat',
      initialScreenSubmitButtonLabel: 'Start Chat',
      website_url: 'https://sbx-ermclinsphere.wcgclinical.com',
    },
  },
  enableReviewerMaterials: true,
};
